export default {
	type: 'object',
	properties: {
		id: { type: 'string' },
		couponName: { type: 'string' },
	},
	required: ['couponName'],
	additionalProperties: false,
}
